export default function ContractsPerEmployee() {
  return (
    <section className="sales-layout__page">
      <h1>Mitarbeiterverträge</h1>
      <p>Die Verträge der Mitarbeiter sind in Vorbereitung.</p>
    </section>
  );
}
